// extracted by mini-css-extract-plugin
export default {"rightSide":"adduser_rightSide__WqngW","user":"adduser_user__PjCuT","bottomPart":"adduser_bottomPart__ptErm","hide":"adduser_hide__e+vcH","show":"adduser_show__b5i5N"};